import { useEffect, useState } from "react";
import EndPointService from "../services/endpoint";
import "./Server.scss";

export default function Server({
  server = "",
  setServer = (value: string) => {},
  setPort = (value: number) => {},
}: {
  server?: string;
  setServer?: (value: string) => void;
  setPort?: (value: number) => void;
}) {
  const [filteredServeurList, setFilteredServeurList] = useState<
    { id: number; name: string; port: string }[]
  >([]);
  const [isServerListVisible, setIsServerListVisible] = useState(false);
  const [serveurList, setServeurList] = useState<
    { id: number; name: string; port: string }[]
  >([]);

  useEffect(() => {
    EndPointService.servers().then((servers) => {
      setServeurList(servers);
      setFilteredServeurList(servers);
    });
  }, []);

  const setFormServer = (value: string) => {
    setServer(value);
    const filtered = serveurList.filter((server) =>
      server.name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredServeurList(filtered);
  };

  const onClickServer = (server: {
    id: number;
    name: string;
    port: string;
  }) => {
    setFormServer(server.name);
    setPort(Number(server.port));
  };

  return (
    <>
      <div className="line-input-wraper">
        <label htmlFor="server">Serveur:</label>
        <div className="line-input-server-container">
          <input
            id="server"
            type="text"
            value={server}
            onChange={(e) => setFormServer(e.target.value)}
            onFocus={() => setIsServerListVisible(true)}
            onBlur={() => setIsServerListVisible(false)}
            autoComplete="off"
          />
          <button
            className="server-input-button"
            type="button"
            onClick={() => setFormServer("")}
          >
            x
          </button>
        </div>
      </div>
      {isServerListVisible && (
        <div className="server-list-container-wrapper">
          <div className="server-list-container">
            <ul className="server-list">
              {filteredServeurList.length > 0 ? (
                filteredServeurList.map((server, index) => (
                  <li
                    className="server"
                    key={index}
                    onMouseDown={() => onClickServer(server)}
                  >
                    {server.name}
                  </li>
                ))
              ) : (
                <li className="server no-result">Aucun résultat trouvé</li>
              )}
            </ul>
          </div>
        </div>
      )}
    </>
  );
}
